class FieldSelectedCount {
  #field
  #inputs
  #label

  static init() {
    const multiselects = document.querySelectorAll('[data-field="multiselect"]')
    if (multiselects.length) {
      const fields = Array.from(multiselects).map(multiselect => new FieldSelectedCount(multiselect))

      const resetButtons = document.querySelectorAll('button[type="reset"]')
      if (resetButtons.length) {
        Array.from(resetButtons)
          .forEach(button => {
            button.addEventListener('click', () => {
              fields.forEach(field => field.reset())
            })
          })
      }
    }
  }

  constructor(el) {
    this.#field = el
    this.#inputs = Array.from(el.querySelectorAll('input:not([role="combobox"])'))
    this.#label = el.querySelector('[data-field-count]')

    this.#inputs.forEach(input => {
      const setCount = () => {
        const count = this.#inputs.filter(input => input.checked).length
        this.#label.textContent = count > 0 ? `(${count})` : ''
      }

      input.addEventListener('change', setCount)
      setCount()
    })
  }

  reset() {
    const event = new Event('change', {bubbles: true})
    this.#inputs.forEach(input => input.dispatchEvent(event))
  }
}

class FieldToggles {
  static init() {
    const container = document.querySelector('[data-filters]')
    if (!container) return
    const toggles = Array.from(container.querySelectorAll('input[role="combobox"]'))

    document.body.addEventListener('click', (e) => {
      if (e.target.closest('input[role="combobox"], label:has(input[role="combobox"]), input[type="checkbox"], label:has(input[type="checkbox"])')) {
        return
      }

      toggles.forEach(toggle => toggle.checked = false)
    })
  }
}

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.listing-filters[data-filters] input[checked]').forEach(input => {
    input.checked = true
    input.removeAttribute('checked')
  })

  FieldSelectedCount.init()
  FieldToggles.init()
})

document.body.addEventListener('htmx:afterSwap', function (evt) {
  const target = evt.detail.target

  if (target && target.id === 'listing-results') {
    const filters = document.querySelector('.listing-filters')
    filters.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' })
  }
})

document.body.addEventListener('htmx:configRequest', (event) => {
  const params = event.detail.parameters

  Object.keys(params).forEach((key) => {
    if (params[key] === '') {
      delete params[key]
    }
  })
})
